import { useState, useRef, useEffect } from "react";

import styles from "./loginPage.module.css";
import AppBar from "../../components/appBar/appBar";
import PopupWithImage from "../../components/popupWithImage/popupWithImage";
import AbortGame from "../../components/abortGame/abortGame";
import ImgBuilder from "../../assets/ImgBuilder";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { loginUser, getUserInfo } from "../../api/api";
import { useUserData } from '../../functions/updateUserData';

const LoginPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const reporterIdQuestionText = t("setup.reporter_id_question");
  const notRegisteredText = t("setup.not_registered");
  const continueButtonText = t("setup.login");

  const [userCode, setUserCode] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const { setUserData } = useUserData();
  const [loading, setLoading] = useState(false);
  const [wrongLogin, setWrongLogin] = useState(false);
  


  const handleLogin = async (userCodeRecieved) => {
    if (loading) return;
    if (userCodeRecieved.length !== 6 && userCodeRecieved !== "new") return;
    
    try {
      setLoading(true);
      // I assume no capital letters are given to the code
      // If they are, then I cannot use the font family "hacked"
      // as it capitalizes all letters and no diff is visible
      const response = await loginUser(userCodeRecieved.toLowerCase());

      if (response.access_token) {
        const tokens = {
          "access_token": response.access_token, 
          "user_code": response.user_code
        }

        setUserData(prev => ({
          ...prev,
          tokens
        }));  
        
        // Navigation fork -> skip all question if registered
        // -> go to ageselection otherwise
        // -> go to "you code" page is and the to "ageselection" if new
        try {
          const responseUser = await getUserInfo(tokens["access_token"]);
          // Here are all of the forks
          if (responseUser.user_register_complete){
            // skip the survey and perhaps add the data to app-userdata
            setUserData(prev => ({
              ...prev,
              "media_survey_complete": responseUser.media_survey_complete
            })); 
            const teenGroup = ["10-12","13-15","16-17"]
            if (teenGroup.includes(responseUser.age_group)){
              setUserData(prev => ({
                ...prev,
                "responded_demographic":true
              })); 
              navigate("/social");
            } else{
              navigate("/topics"); // to the game
            }
          } else{
            navigate("/age");
          }
        } catch (error) {
          console.error("Session init failed:", error);
          setLoading(false);
        }
      }
    } catch (err) {
      setWrongLogin(true)
    } finally {
      setLoading(false);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleChange = (index, e) => {
    const val = e.target.value.replace(/[^0-9a-zA-Z]/, "");
    if (!val) return;
    const newCode = userCode.split("");
    newCode[index] = val;
    setUserCode(newCode.join(""));

    const next = document.getElementById(`code-box-${index + 1}`);
    if (next) next.focus();
  };

  const handleKeyDown = (index, e) => {
    const newCode = userCode.split("");

    if (e.key === "Backspace") {
      e.preventDefault();

      if (userCode[index]) {
        newCode[index] = "";
        setUserCode(newCode.join(""));
      } else if (index > 0) {
        const prev = document.getElementById(`code-box-${index - 1}`);
        if (prev) prev.focus();

        newCode[index - 1] = "";
        setUserCode(newCode.join(""));
      }
    }
  };

  return (
    <div className={styles.wrapperLogin}>
      <AppBar />
      <AbortGame />
      {wrongLogin &&
        <PopupWithImage
          name={t(`pop_up_notifications.wrong_login_name`)}
          description={t(`pop_up_notifications.wrong_login_description`)}
          button={t(`pop_up_notifications.wrong_login_button`)}
          type={"confirmation"}
          defContinue={() => setWrongLogin(false)}
        />    
      }
      {!isLoaded && <div className={styles.loaderWrapper}><div className={styles.loader}></div></div>}
      <img style={{
        opacity: isLoaded ? 1 : 0,
          transition: "opacity 0.2s ease-in-out",
        }}
      onLoad={() => setIsLoaded(true)} alt="badge"  src={ImgBuilder.badgeCropped} className={styles.enterIdImage}/>
      <div className={styles.badgeUpper}></div>
      <div className={styles.badge}>
        <div className={styles.innerBadge}>
          <p className={styles.textBadge}>
            {reporterIdQuestionText}
          </p>
          <div className={styles.containerID}>
             {[...Array(6)].map((_, index) => (
              <input 
                ref={index === 0 ? inputRef : null}
                key={index}
                autoComplete="off"
                className={styles.singleKeyInput}
                maxLength={1}
                type="text"
                value={userCode[index] || ""}
                onChange={(e) => handleChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                id={`code-box-${index}`}
              />
             ))}
          </div>
          <div className={styles.sealContainer}>
            <button onClick={() => handleLogin(userCode)} className={styles.buttonContinue}>{continueButtonText}</button>
              <img alt="invisible seal" className={styles.seal} src={ImgBuilder.seal}/>
            </div>
          
        </div>
      </div>
      <div className={styles.noIdContainer}>
        <p onClick={() => handleLogin('new')} className={styles.noId}>{notRegisteredText}</p>
      </div>
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.smallDotsBg}/>

    </div>
  );
};

export default LoginPage;
